import React from "react";

export const Footer = () => {
  return (
    <div id="footer">
      <p>&copy; 2023 TechShoor Agri. All rights reserved.</p>
    </div>
  );
};
